import React from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { string, func } from 'prop-types';
import './styles/global-styles.scss';
import { Error } from './pages';
import { getRoutes } from './routes';

export const App = ({ currentRouteName, currentRouteComponent }) => {
  const routes = getRoutes(currentRouteName, currentRouteComponent);
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route exact path={routes.homeV2.path} element={<routes.homeV2.component />} />
        <Route exact path={routes.balance.path} element={<routes.balance.component />} />
        <Route exact path={routes.list.path} element={<routes.list.component />} />
        <Route exact path={routes.thirdParty.path} element={<routes.thirdParty.component />} />
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};

App.propTypes = {
  currentRouteName: string,
  currentRouteComponent: func
};

App.defaultProps = {
  currentRouteName: null,
  currentRouteComponent: null
};
